// tslint:disable
export var AccountExternalIdType;
(function (AccountExternalIdType) {
    // UNKN
    AccountExternalIdType[AccountExternalIdType["UNKN"] = 0] = "UNKN";
    // UBCHUBID
    AccountExternalIdType[AccountExternalIdType["UBCHUBID"] = 1] = "UBCHUBID";
    // TrialCardHubId
    AccountExternalIdType[AccountExternalIdType["TrialCardHubId"] = 2] = "TrialCardHubId";
    // MemberNumber
    AccountExternalIdType[AccountExternalIdType["MemberNumber"] = 3] = "MemberNumber";
    // ADLDS
    AccountExternalIdType[AccountExternalIdType["ADLDS"] = 4] = "ADLDS";
    // MedMemberID
    AccountExternalIdType[AccountExternalIdType["MedMemberID"] = 5] = "MedMemberID";
    // PharMemberID
    AccountExternalIdType[AccountExternalIdType["PharMemberID"] = 6] = "PharMemberID";
    // THIRDPARTYID
    AccountExternalIdType[AccountExternalIdType["THIRDPARTYID"] = 7] = "THIRDPARTYID";
    // ARXRxId
    AccountExternalIdType[AccountExternalIdType["ARXRxId"] = 8] = "ARXRxId";
    // CarePathId
    AccountExternalIdType[AccountExternalIdType["CarePathId"] = 9] = "CarePathId";
    // VMIPatientId
    AccountExternalIdType[AccountExternalIdType["VMIPatientId"] = 10] = "VMIPatientId";
    // PorticoPortalId
    AccountExternalIdType[AccountExternalIdType["PorticoPortalId"] = 11] = "PorticoPortalId";
    // SiteAccountId
    AccountExternalIdType[AccountExternalIdType["SiteAccountId"] = 12] = "SiteAccountId";
    // patientMckId
    AccountExternalIdType[AccountExternalIdType["PatientMckId"] = 13] = "PatientMckId";
    // RemsId
    AccountExternalIdType[AccountExternalIdType["RemsId"] = 14] = "RemsId";
    // MangoActivationId
    AccountExternalIdType[AccountExternalIdType["MangoActivationId"] = 15] = "MangoActivationId";
    // PatientPartnerId
    AccountExternalIdType[AccountExternalIdType["PatientPartnerId"] = 16] = "PatientPartnerId";
    // PartnerPatientId
    AccountExternalIdType[AccountExternalIdType["PartnerPatientId"] = 17] = "PartnerPatientId";
    // SunovionID
    AccountExternalIdType[AccountExternalIdType["SunovionID"] = 18] = "SunovionID";
    // PharmaCordPatientId
    AccountExternalIdType[AccountExternalIdType["PharmaCordPatientId"] = 19] = "PharmaCordPatientId";
    // IBondId
    AccountExternalIdType[AccountExternalIdType["IBondId"] = 20] = "IBondId";
    // IBondEnrollmentId
    AccountExternalIdType[AccountExternalIdType["IBondEnrollmentId"] = 21] = "IBondEnrollmentId";
})(AccountExternalIdType || (AccountExternalIdType = {}));
AccountExternalIdType['TRIALCARDHUBID'] = 2;
AccountExternalIdType['MEMBERNUMBER'] = 3;
AccountExternalIdType['MEDMEMBERID'] = 5;
AccountExternalIdType['PHARMEMBERID'] = 6;
AccountExternalIdType['ARXRXID'] = 8;
AccountExternalIdType['CAREPATHID'] = 9;
AccountExternalIdType['VMIPATIENTID'] = 10;
AccountExternalIdType['PORTICOPORTALID'] = 11;
AccountExternalIdType['SITEACCOUNTID'] = 12;
AccountExternalIdType['PATIENTMCKID'] = 13;
AccountExternalIdType['REMSID'] = 14;
AccountExternalIdType['MANGOACTIVATIONID'] = 15;
AccountExternalIdType['PATIENTPARTNERID'] = 16;
AccountExternalIdType['PARTNERPATIENTID'] = 17;
AccountExternalIdType['SUNOVIONID'] = 18;
AccountExternalIdType['PHARMACORDPATIENTID'] = 19;
AccountExternalIdType['IBONDID'] = 20;
AccountExternalIdType['IBONDENROLLMENTID'] = 21;
//# sourceMappingURL=AccountExternalIdType.js.map